import React, { createContext, useContext, useState } from 'react';

/**
 * BreadcrumbContext
 *
 * Lets feature pages push extra breadcrumb segments beyond what the URL alone
 * provides (e.g. in-page drilldown levels that don't change the route).
 *
 * Shape of each segment:
 *   { label: string, onClick?: () => void }
 *
 * Usage in a page:
 *   const { setSegments } = useBreadcrumb();
 *   useEffect(() => {
 *     setSegments([{ label: permit.permit_name, onClick: () => setDrill(null) }]);
 *     return () => setSegments([]);
 *   }, [permit]);
 */

const BreadcrumbContext = createContext({
  segments: [],
  setSegments: () => {},
});

export function BreadcrumbProvider({ children }) {
  const [segments, setSegments] = useState([]);

  return (
    <BreadcrumbContext.Provider value={{ segments, setSegments }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  return useContext(BreadcrumbContext);
}
